import { useDispatch, useSelector, useStore } from 'react-redux';

import type { AppDispatch, RootState, store } from './store';

// From https://react-redux.js.org/using-react-redux/usage-with-typescript#define-typed-hooks
// Use throughout your app instead of plain `useDispatch` and `useSelector` to avoid verbose typing
export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();
export const useAppStore = useStore.withTypes<typeof store>();
